import axios from "axios";
import { BASE_API_URL } from "../consts";

export type ActivityAction = "CREATE" | "UPDATE" | "DELETE" | "LOGIN";

export type ActivityModule =
  | "dailyRevenue"
  | "userProfile"
  | "finance"
  | "apartmentReservation"
  | "tableReservation"
  | "shifts"
  | "credit"
  | "auth"
  | "hr"
  | "accessControl"
  | "supplier"
  | "investment"
  | "documents"
  | "settings"
  | "subscription"
  | "support"
  | "patients"
  | "venueEvent";

export interface ActivityLog {
  _id: string;
  performedBy?: { _id: string; firstName?: string; lastName?: string } | null;
  performedByName: string;
  action: ActivityAction;
  module: ActivityModule;
  entityId?: string;
  entityLabel?: string;
  changes?: string;
  clientId: string;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
  updatedAt: string;
}

export interface GetActivityLogsParams {
  module?: ActivityModule;
  action?: ActivityAction;
  startDate?: string;
  endDate?: string;
  userId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface ActivityLogsResponse {
  logs: ActivityLog[];
  total: number;
  page: number;
  limit: number;
}

export interface ActivityStats {
  total: number;
  byModule: { _id: ActivityModule; count: number }[];
  byAction: { _id: ActivityAction; count: number }[];
}

export const getActivityLogs = (clientId: string, params: GetActivityLogsParams = {}) =>
  axios.get<ActivityLogsResponse>(`${BASE_API_URL}/activity-trail/${clientId}`, { params });

export const getActivityStats = (clientId: string, params: { startDate?: string; endDate?: string } = {}) =>
  axios.get<ActivityStats>(`${BASE_API_URL}/activity-trail/${clientId}/stats`, { params });

// Super-admin only: bulk cleanup of old activity trail logs, across every client.
export const previewActivityCleanup = (olderThanDays: number) =>
  axios.get<{ count: number; cutoff: string }>(
    `${BASE_API_URL}/activity-trail/cleanup/preview`,
    { params: { olderThanDays } },
  );

export const cleanupActivityLogs = (olderThanDays: number) =>
  axios.delete<{ deletedCount: number; cutoff: string }>(
    `${BASE_API_URL}/activity-trail/cleanup`,
    { data: { olderThanDays } },
  );
